import { PageProps } from '@anm/contexts/VideoTemplatesPageContext';
import pages, { TemplatePage } from '@anm/data/video-templates/pages';
import { safeParse } from '@anm/helpers/safeOperation';
import usePageParams from '@anm/hooks/usePageParams';
import { memo, FC } from 'react';
import * as semrush from '@anm/helpers/semrush'

import CustomizeTemplateInfo from './CustomizeTemplateInfo';
import FooterCategories from './FooterCategories';
import FooterDescription from './FooterDescription';

const TemplatePageFooter: FC<PageProps> = ({ pageName }) => {
  const {
    footer: { showCustomizeVideo = true }
  } = pages[pageName] as TemplatePage;

  const { isSemrush } = usePageParams<{ isSemrush: string }>();
  const isSemrushParsed = safeParse(isSemrush || 'false') || semrush.isSemrushIframe();

  return (
    <>
      {showCustomizeVideo && !isSemrushParsed && <CustomizeTemplateInfo />}
      {!isSemrushParsed && <FooterDescription />}
      <FooterCategories />
    </>
  );
};

export default memo(TemplatePageFooter);
